import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {Certificate2Service} from 'src/app/services/certificate2.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-certificates-speakers-dialog',
  templateUrl: './certificates-speakers-dialog.component.html',
  styleUrls: [ './certificates-speakers-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class CertificatesSpeakersDialogComponent implements OnInit {

  public config: any;
  public matcher = new FormErrorStateMatcher(); // 
  public certificateForm: FormGroup;

  public objectImage: any = null;
  public storedImage: any;

  public isEdit: boolean;

  constructor (
    public matDialogRef: MatDialogRef<CertificatesSpeakersDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    public _certificateService: Certificate2Service,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log("dialog data: " + JSON.stringify(this.data));
    this.getConfig(this.data.id)
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
  }

  async getConfig (id: any) {
    this.config = await this._certificateService.getConfig(id)
    if (this.config) {
      console.log("tem config")
      this.certificateForm = this.createForm(this.config)
    } else {
      console.log("não tem config")
      this.certificateForm = this.createForm(this.data)
    }
  }

  createForm (data: any) {

    console.log("data: " + JSON.stringify(data));
    let form: FormGroup = this.fb.group({
      event_id: new FormControl(data.id),
      event_name: new FormControl(data.event_name),
      isCongress: new FormControl(data.isCongress),
      staff_role: new FormControl(data.staff_role),
      staff_qrCode: new FormControl(data.staff_qrCode, [ Validators.required ]),
      staff_image_url: new FormControl(data.staff_image_url)
    });

    this.storedImage = data.staff_image_url;
    
    return form
  }


  previewImage (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[ 0 ];
    }
  }

};
